import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { MarketingExpensesTitle } from '../../../Constant';
import { barChart } from '../../../Data/Widgets/Chart/ChartData';

const MarketingExpenses = () => {
  return (
    <>
      <Col xl='7' md='12' className='box-col-7'>
        <Card className='o-hidden'>
          <CardHeader className='pb-0'>
            <H5>{MarketingExpensesTitle}</H5>
          </CardHeader>
          <div className='bar-chart-widget'>
            <CardBody className='bottom-content'>
              <Row>
                <Col xs='12'>
                  <div id='chart-widget4'>
                    <ReactApexChart options={barChart.options} series={barChart.series} height='380' type='bar' />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </div>
        </Card>
      </Col>
    </>
  );
};
export default MarketingExpenses;
